import React from 'react';
import { Bone } from '../Bone/Bone';
import type { IntegrationsSkeletonKind } from '../integrationsSkeletonKind';
import { TabSkeleton } from '../TabSkeleton/TabSkeleton';
import './PageSkeleton.css';

export interface PageSkeletonProps {
  kind: IntegrationsSkeletonKind;
}

/**
 * The Integrations page while it loads, in PageShell's frame: breadcrumb, then the card with
 * title, subtitle and search, the tabs, and the tab's content. The route's fallback and
 * RouteSkeleton both draw it, so a cold load keeps one shape.
 */
export function PageSkeleton({ kind }: PageSkeletonProps): React.ReactElement {
  return (
    <div className="integrations-page-skeleton">
      <Bone className="integrations-page-skeleton__crumb" />
      <div className="integrations-page-skeleton__card">
        <div className="integrations-page-skeleton__header">
          <div className="integrations-page-skeleton__heading">
            <Bone className="integrations-page-skeleton__title" />
            <Bone className="integrations-page-skeleton__line" />
            <Bone className="integrations-page-skeleton__line integrations-page-skeleton__line--phone" />
            <Bone className="integrations-page-skeleton__line integrations-page-skeleton__line--short" />
          </div>
          {kind === 'providers' ? <Bone className="integrations-page-skeleton__search" /> : null}
        </div>
        <Bone className="integrations-page-skeleton__tabs" />
        <TabSkeleton kind={kind} />
      </div>
    </div>
  );
}
